<template>
  <el-card class="custom-print-sys-content">
    <el-row
      :gutter="8"
      style="margin-bottom: 10px"
      class="custom-print-sys-content-top"
    >
      <el-col>
        <el-card>
          <div class="top-button-group">
            <!-- 纸张类型 -->
            <el-button-group class="top-button-group-1">
              <el-button
                :type="curPaperType == type ? 'primary' : 'info'"
                v-for="(value, type) in paperTypes"
                :key="type"
                @click="setPaper(type, value)"
              >
                {{ type }}
              </el-button>
              <el-popover
                v-model="paperPopVisible"
                title="设置纸张宽高(mm)"
                trigger="click"
              >
                <div style="width: 200px">
                  <el-row :span="24">
                    <el-col :span="10">
                      <el-input
                        type="number"
                        v-model="paperWidth"
                        style="width: 100%; text-align: center"
                        placeholder="宽(mm)"
                      />
                    </el-col>
                    <el-col
                      :span="4"
                      style="text-align: center; line-height: 30px"
                    >
                      ~
                    </el-col>
                    <el-col :span="10">
                      <el-input
                        type="number"
                        v-model="paperHeight"
                        style="width: 100%; text-align: center; border-left: 0"
                        placeholder="高(mm)"
                      />
                    </el-col>
                  </el-row>
                  <el-button
                    type="primary"
                    style="width: 100%; margin-top: 5px"
                    @click="otherPaper"
                    >确定</el-button
                  >
                </div>
                <el-button
                  slot="reference"
                  :type="curPaperType == 'other' ? 'primary' : 'info'"
                  >自定义纸张</el-button
                >
              </el-popover>
              <el-popover title="常用纸张规格" trigger="hover">
                <span style="color: red"
                  >使用方法：如果需要横向打印A4纸，请点击自定义纸张，设置宽高297x210</span
                ><br />
                <span>A0：841x1189 <span class="separate">|</span> B0：</span
                >1000x1414 <span class="separate">|</span> C0：917x1297<br />
                <span>A1：594x841 <span class="separate">|</span> B1：</span
                >707x1000 <span class="separate">|</span> C1：648x917<br />
                <span>A2：420x594 <span class="separate">|</span> B2：</span
                >500x707 <span class="separate">|</span> C2：458x648<br />
                <span>A3：297x420 <span class="separate">|</span> B3：</span
                >353x500 <span class="separate">|</span> C3：324x458<br />
                <span>A4：210x297 <span class="separate">|</span> B4：</span
                >250x353 <span class="separate">|</span> C4：229x324<br />
                <span>A5：148x210 <span class="separate">|</span> B5：</span
                >176x250 <span class="separate">|</span> C5：162x229<br />
                <span>A6：105x148 <span class="separate">|</span> B6：</span
                >125x176 <span class="separate">|</span> C6：114x162<br />
                <span>A7：74x105 <span class="separate">|</span> B7：</span
                >88x125 <span class="separate">|</span> C7：81x114<br />
                <span>A8：52x74 <span class="separate">|</span> B8：</span>62x88
                <span class="separate">|</span> C8：57x81<br />
                <span>A9：37x52 <span class="separate">|</span> B9：</span>44x62
                <span class="separate">|</span> C9：40x57<br />
                <span>A10：26x37 <span class="separate">|</span> B10：</span
                >31x44 <span class="separate">|</span> C10：28x40<br />
                <i
                  slot="reference"
                  class="el-icon-question"
                  style="
                    position: relative;
                    top: -19px;
                    right: 0px;
                    font-size: 20px;
                    cursor: pointer;
                  "
                ></i>
              </el-popover>
            </el-button-group>

            <!-- 工作区放大与缩小 -->
            <el-button
              plain
              icon="el-icon-zoom-out"
              @click="changeScale(false)"
            ></el-button>
            <el-input
              class="elinputscalebox"
              :value="scaleValue"
              :min="scaleMin"
              :max="scaleMax"
              :step="0.1"
              disabled
              style="width: 70px"
            />
            <el-button
              plain
              icon="el-icon-zoom-in"
              @click="changeScale(true)"
            ></el-button>

            <!-- 预览/打印 -->
            <el-button-group class="top-button-group-2">
              <el-button type="primary" icon="el-icon-view" @click="preView">
                {{ printType == 1 ? "预览" : "打印" }}
              </el-button>
            </el-button-group>
            <!-- 保存/清空 -->
            <el-button-group style="margin-left: 10px">
              <el-button type="primary" icon="el-icon-collection" @click="save">
                {{ printType == 1 ? "保存" : "修改" }}
              </el-button>
              <el-popconfirm
                title="是否确认清空?"
                confirm-button-text="好的"
                cancel-button-text="不用了"
                icon="el-icon-info"
                icon-color="red"
                @confirm="clearPaper"
              >
                <el-button type="danger" slot="reference" icon="el-icon-delete">
                  清空
                </el-button>
              </el-popconfirm>
            </el-button-group>
          </div>
          <div class="top-align-group" style="margin-top: 15px">
            <el-button-group class="top-button-group-1">
              <el-button plain @click="setElsAlign('left')"> 左对齐 </el-button>
              <el-button plain @click="setElsAlign('vertical')">
                居中
              </el-button>
              <el-button plain @click="setElsAlign('right')">
                右对齐
              </el-button>
              <el-button plain @click="setElsAlign('top')">
                顶部对齐
              </el-button>
              <el-button plain @click="setElsAlign('horizontal')">
                垂直居中
              </el-button>
              <el-button plain @click="setElsAlign('bottom')">
                底部对齐
              </el-button>
            </el-button-group>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="8" class="custom-print-sys-content-body">
      <el-col :span="4" class="body-left">
        <el-card class="body-card">
          <el-row>
            <el-col
              :span="24"
              class="rect-printElement-types hiprintEpContainer2"
              id="customPrintSysEpContainer"
            >
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="14" class="body-middle">
        <el-card class="card-design body-card">
          <div id="customPrintSysTemplate" class="hiprint-printTemplate"></div>
        </el-card>
      </el-col>
      <el-col :span="6" class="params_setting_container body-right">
        <el-card class="body-card">
          <el-row class="hinnn-layout-sider">
            <div id="PrintElementOptionSetting"></div>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <!-- 保存信息 -->
    <el-dialog
      v-dialogDrag
      append-to-body
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="300px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="print-custom-dialog-save"
    >
      <div slot="title" class="dialog-title">
        <i class="el-icon-edit"></i>
        <div class="dialog-title-word">请输入表单的内容</div>
      </div>
      <div class="dialog-body">
        <el-form :model="form">
          <el-form-item label="模板名称" label-width="120px">
            <el-input v-model="form.modelName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="模板类型" label-width="120px">
            <!-- statusValList -->
            <el-select v-model="form.modelType" placeholder="请选择模板类型">
              <el-option
                v-for="(value, key) in statusValList"
                :key="key"
                :label="value.showName"
                :value="value.showName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button @click="handleConfirm" type="primary" size="small"
          >确认</el-button
        >
        <el-button @click="handleClose" size="small">关闭</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>
  
<script>
// 原理：通过接口，获取字段，数据覆盖到相应字段即可
import { hiprint } from "@/print.js";
import providers from "./providers";

let hiprintTemplate;
export default {
  name: "printSys",
  props: {
    // 模板数据
    modelObj: {
      type: Object,
      default: () => {},
    },
    // 选中的数据，特别是批量打印
    selectTableData: {
      type: Array,
      default: () => [],
    },
    // 打印类型（新增或预览）
    printType: {
      type: [Number, String],
      default: 1,
    },
    modelClassName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      deactivated: false,
      // 模板选择
      mode: 0,
      modeList: [],
      // 当前纸张
      curPaper: {
        type: "other",
        width: 220,
        height: 80,
      },
      jsonIn: "",
      jsonOut: "",
      // 纸张类型
      paperTypes: {
        A3: {
          width: 420,
          height: 296.6,
        },
        A4: {
          width: 210,
          height: 296.6,
        },
        A5: {
          width: 210,
          height: 147.6,
        },
        B3: {
          width: 500,
          height: 352.6,
        },
        B4: {
          width: 250,
          height: 352.6,
        },
        B5: {
          width: 250,
          height: 175.6,
        },
      },
      scaleValue: 1,
      scaleMax: 5,
      scaleMin: 0.5,
      // 自定义纸张
      paperPopVisible: false,
      paperWidth: "297",
      paperHeight: "210",
      lastjson: "",
      printObj: {},
      ajaxData: {},
      testId: [21],
      testIdArr: [7, 8, 21],
      dialogVisible: false,
      form: {
        modelName:
          this.modelObj && this.printType == 2 ? this.modelObj.modelName : "",
        modelType:
          this.modelObj && this.printType == 2 ? this.modelObj.modelType : "",
      },
      className: this.modelObj
        ? this.modelObj.className
          ? this.modelObj.className
          : this.modelClassName
        : this.modelClassName,
      statusValList: [], // 模板类型
      curPaperType: "A4",
    };
  },
  computed: {
    // 纸张类型
    // curPaperType: {
    //   get() {
    //     let type = "other";
    //     let types = this.paperTypes;
    //     for (const key in types) {
    //       let item = types[key];
    //       let { width, height } = this.curPaper;
    //       if (item.width === width && item.height === height) {
    //         type = key;
    //       }
    //     }
    //     return type;
    //   },
    //   set(v) {
    //     return v;
    //   },
    // },
    // 默认的表格
    defaultPrintTable() {
      let arr = [
        {
          tid: "aProviderModule.table",
          title: "表格",
          type: "table",
          options: {
            field: "",
            tableHeaderRepeat: "first",
            tableFooterRepeat: "last",
            fields: [{ text: "None", field: "none" }],
          },
          editable: true,
          columnDisplayEditable: true, //列显示是否能编辑
          columnDisplayIndexEditable: true, //列顺序显示是否能编辑
          columnTitleEditable: true, //列标题是否能编辑
          columnResizable: true, //列宽是否能调整
          columnAlignEditable: true, //列对齐是否调整
          isEnableEditField: true, //编辑字段
          isEnableContextMenu: true, //开启右键菜单 默认true
          isEnableInsertRow: true, //插入行
          isEnableDeleteRow: true, //删除行
          isEnableInsertColumn: true, //插入列
          isEnableDeleteColumn: true, //删除列
          isEnableMergeCell: true, //合并单元格
          columns: [
            [{ title: "None", field: "none", align: "center", width: 150 }],
          ],
          rowsColumnsMerge: function (data, row, index) {},
          footerFormatter: function (
            options,
            rows,
            data,
            currentPageGridRowsData
          ) {},
        },
      ];
      return arr;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.changeMode();
    });
  },
  methods: {
    // 模板类型弹出框关闭
    handleClose() {
      this.dialogVisible = false;
    },
    // 创建打印表格
    createTable(arr) {
      if (arr && this.$getObject(arr) == "Array" && arr.length > 0) {
        let tableArr = [];
        arr.forEach((item, key) => {
          if (
            item.childFields &&
            this.$getObject(item.childFields) == "Array" &&
            item.childFields.length > 0
          ) {
            let childFieldsArr = item.childFields,
              fieldsArr = [],
              columnsArr = [];
            childFieldsArr.forEach((value, index) => {
              let fieldsObj = {
                text: value.fieldShowName,
                field: value.fieldKey,
              };
              let columnsObj = {
                title: value.fieldShowName,
                field: value.fieldKey,
                align: "center",
                width: value.fieldShowName.length * 75 || 150,
              };
              fieldsArr.push(fieldsObj);
              columnsArr.push(columnsObj);
            });
            let obj = {
              tid: "aProviderModule." + item.fieldKey,
              title: item.fieldShowName,
              type: "table",
              options: {
                field: item.fieldKey,
                tableHeaderRepeat: "first",
                tableFooterRepeat: "last",
                fields: fieldsArr,
              },
              editable: true,
              columnDisplayEditable: true, //列显示是否能编辑
              columnDisplayIndexEditable: true, //列顺序显示是否能编辑
              columnTitleEditable: true, //列标题是否能编辑
              columnResizable: true, //列宽是否能调整
              columnAlignEditable: true, //列对齐是否调整
              isEnableEditField: true, //编辑字段
              isEnableContextMenu: true, //开启右键菜单 默认true
              isEnableInsertRow: true, //插入行
              isEnableDeleteRow: true, //删除行
              isEnableInsertColumn: true, //插入列
              isEnableDeleteColumn: true, //删除列
              isEnableMergeCell: true, //合并单元格
              columns: [columnsArr],
              rowsColumnsMerge: function (data, row, index) {
                // 返回一个数组,参数一为列合并数,参数二为行合并数, 被合并的行或者列值设为0
              },
              footerFormatter: function (
                options,
                rows,
                data,
                currentPageGridRowsData
              ) {},
            };
            tableArr.push(obj);
          } else {
            let obj = {
              tid: "aProviderModule.table",
              title: item.fieldShowName,
              type: "table",
              options: {
                field: item.fieldKey,
                tableHeaderRepeat: "first",
                tableFooterRepeat: "last",
                fields: [{ text: "None", field: "none" }],
              },
              editable: true,
              columnDisplayEditable: true, //列显示是否能编辑
              columnDisplayIndexEditable: true, //列顺序显示是否能编辑
              columnTitleEditable: true, //列标题是否能编辑
              columnResizable: true, //列宽是否能调整
              columnAlignEditable: true, //列对齐是否调整
              isEnableEditField: true, //编辑字段
              isEnableContextMenu: true, //开启右键菜单 默认true
              isEnableInsertRow: true, //插入行
              isEnableDeleteRow: true, //删除行
              isEnableInsertColumn: true, //插入列
              isEnableDeleteColumn: true, //删除列
              isEnableMergeCell: true, //合并单元格
              columns: [
                [{ title: "None", field: "none", align: "center", width: 150 }],
              ],
              rowsColumnsMerge: function (data, row, index) {
                // 返回一个数组,参数一为列合并数,参数二为行合并数, 被合并的行或者列值设为0
              },
              footerFormatter: function (
                options,
                rows,
                data,
                currentPageGridRowsData
              ) {},
            };
            tableArr.push(obj);
          }
        });
        return tableArr;
      } else {
        return this.defaultPrintTable;
      }
    },
    // 创建除了表格的字段
    createFileds(arr) {
      if (arr && this.$getObject(arr) == "Array" && arr.length > 0) {
        let fieldsArr = [];
        arr.forEach((value, index) => {
          let fieldsObj = {
            text: value.fieldShowName,
            field: value.fieldKey,
          };
          fieldsArr.push(fieldsObj);
        });
        return fieldsArr;
      } else {
        return null;
      }
    },
    // 自定义设计的时候 通过初始化 获取设计元素
    initProviders(tableobj, fieldsobj) {
      const opt = {
        fieldsobj: fieldsobj,
        tableobj: tableobj,
      };
      this.printObj = opt;
    },
    changeMode() {
      const _this = this;
      // 获取模板类型
      this.$TOOLS.getStatusValList("print_model_v3.model_type").then((res) => {
        _this.statusValList = res;
      });
      // 获取打印模板字段
      window.sessionStorage.setItem("printFieldsClassName", this.className);
      this.$API
        .getPrintFields({
          className: this.className,
        })
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.status == "success") {
              const result = data.result;
              let option = {
                tabledata: [],
                fieldsdata: [],
              };
              result.forEach((item, key) => {
                if (item.isTable == 1) {
                  option.tabledata.push(item);
                } else {
                  option.fieldsdata.push(item);
                }
              });
              let tableobj = this.createTable(option.tabledata);
              let fieldsobj = this.createFileds(option.fieldsdata);
              _this.initProviders(tableobj, fieldsobj);
              let provider = providers[0];
              hiprint.init({
                providers: [provider.f(_this.printObj)],
              });
              // 初始化设计元素
              // 设置左侧拖拽事件
              $("#customPrintSysEpContainer").empty();
              hiprint.PrintElementTypeManager.build(
                "#customPrintSysEpContainer",
                "aProviderModule"
              );
              // 清空打印区域
              $("#customPrintSysTemplate").empty();
              let templatesData = null;
              if (_this.modelObj && _this.printType == 2) {
                templatesData = JSON.parse(_this.modelObj.content);
                if (templatesData) {
                  if (_this.$getObject(templatesData.panels) == "Array") {
                    let a0 = templatesData.panels[0];
                    console.log(a0, "templatesData.panels");
                    _this.paperWidth = a0.width;
                    _this.paperHeight = a0.height;
                    if (a0.paperType) {
                      _this.curPaperType = a0.paperType;
                    } else {
                      if (a0.width == 420 && a0.height == 296.6) {
                        _this.curPaperType = "A3";
                      } else if (a0.width == 210 && a0.height == 296.6) {
                        _this.curPaperType = "A4";
                      } else if (a0.width == 210 && a0.height == 147.6) {
                        _this.curPaperType = "A5";
                      } else if (a0.width == 500 && a0.height == 352.6) {
                        _this.curPaperType = "B3";
                      } else if (a0.width == 250 && a0.height == 352.6) {
                        _this.curPaperType = "B4";
                      } else if (a0.width == 250 && a0.height == 175.6) {
                        _this.curPaperType = "B5";
                      } else {
                        _this.curPaperType = "other";
                      }
                    }
                  }
                } else {
                  alert("数据初始化出错！");
                }
              } else {
                _this.curPaperType = "A4";
                // 使用A4纸 初始化
                templatesData = {
                  panels: [
                    {
                      index: 0,
                      paperType: "A4",
                      height: 297,
                      width: 210,
                      paperHeader: 43.5,
                      paperFooter: 801,
                      printElements: [],
                      paperNumberLeft: 565,
                      paperNumberTop: 819,
                    },
                  ],
                };
                _this.paperWidth = 210;
                _this.paperHeight = 297;
              }

              hiprintTemplate = new hiprint.PrintTemplate({
                template: templatesData,
                dataMode: 1, // 1:getJson 其他：getJsonTid 默认1
                history: true, // 是否需要 撤销重做功能
                onDataChanged: (type, json) => {
                  // console.log(type); // 新增、移动、删除、修改(参数调整)、大小、旋转
                  // 更新模板
                  // hiprintTemplate.update(json)
                },
                settingContainer: "#PrintElementOptionSetting",
                paginationContainer: ".hiprint-printPagination",
                // 图片选择功能
                onImageChooseClick: (target) => {
                  let fileResult = document.createElement("input");
                  fileResult.id = "fileResult";
                  fileResult.type = "file";
                  fileResult.accept = "image/*";
                  fileResult.click();
                  fileResult.onchange = function (e) {
                    let file = e.target.files[0];
                    let freader = new FileReader();
                    freader.readAsDataURL(file);
                    freader.onload = function (e) {
                      target.refresh(e.target.result);
                    };
                  };
                },
              });
              hiprintTemplate.design("#customPrintSysTemplate");
              // 获取当前放大比例, 当zoom时传true 才会有
              this.scaleValue = hiprintTemplate.editingPanel.scale || 1;
            }
          }
        });
    },
    /**
     * 设置纸张大小
     * @param type [A3, A4, A5, B3, B4, B5, other]
     * @param value {width,height} mm
     */
    setPaper(type, value) {
      try {
        if (Object.keys(this.paperTypes).includes(type)) {
          this.curPaper = {
            type: type,
            width: value.width,
            height: value.height,
          };
          hiprintTemplate.setPaper(value.width, value.height);
        } else {
          this.curPaper = {
            type: "other",
            width: value.width,
            height: value.height,
          };
          hiprintTemplate.setPaper(value.width, value.height);
        }
        this.curPaperType = type;
      } catch (error) {
        this.$message.error(`操作失败: ${error}`);
      }
    },
    changeScale(big) {
      let scaleValue = this.scaleValue;
      if (big) {
        scaleValue += 0.1;
        if (scaleValue > this.scaleMax) scaleValue = 5;
      } else {
        scaleValue -= 0.1;
        if (scaleValue < this.scaleMin) scaleValue = 0.5;
      }
      if (hiprintTemplate) {
        // scaleValue: 放大缩小值, false: 不保存(不传也一样), 如果传 true, 打印时也会放大
        hiprintTemplate.zoom(scaleValue, true);
        this.scaleValue = scaleValue;
      }
    },
    // 其他尺寸
    otherPaper() {
      let value = {};
      value.width = this.paperWidth;
      value.height = this.paperHeight;
      this.paperPopVisible = false;
      this.setPaper("other", value);
    },
    // 相对排版
    setElsAlign(e) {
      hiprintTemplate.setElsAlign(e);
    },
    // 预览
    preView() {
      const _this = this;
      console.log(this.selectTableData, "this.selectTableData");
      console.log(this.modelClassName, "this.modelClassName");

      if (
        this.modelClassName ==
        "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo.AdminOutgoingPrintBillDataV3tmsVo"
      ) {
        // 获取this.selectTableData中选择数据的outgoingId数组，作为预览的数据
        let idarr = [];
        for (let i = 0; i < this.selectTableData.length; i++) {
          idarr.push(this.selectTableData[i].outgoingId);
        }
        this.$API
          .getOutgoingTabPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                _this.ajaxData = result;
                hiprintTemplate.print(_this.ajaxData, {});
                // console.log(_this.ajaxData, "_this.ajaxData");
              }
            }
          });
      } else if (
        this.modelClassName ==
        "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo"
      ) {
        // 获取this.selectTableData中选择数据的outgoingId数组，作为预览的数据
        let idarr = [];
        for (let i = 0; i < this.selectTableData.length; i++) {
          idarr.push(this.selectTableData[i].outgoingId);
        }
        // 外发承运商清单
        this.$API
          .getOutgoingPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                _this.ajaxData = result;
                hiprintTemplate.print(_this.ajaxData, {});
              }
            }
          });
      } else if (
        this.modelClassName ==
        "com.bami.service.tms.v3.admin.print.vo.AdminCarCostPrintDataV3tmsVo"
      ) {
        // 获取this.selectTableData中选择数据的outgoingId数组，作为预览的数据
        let idarr = [];
        for (let i = 0; i < this.selectTableData.length; i++) {
          idarr.push(this.selectTableData[i].dispatchId);
        }
        // 获取车辆成本打印数据
        this.$API
          .getCarCostPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                _this.ajaxData = result;
                hiprintTemplate.print(_this.ajaxData, {});
              }
            }
          });
      } else if (
        this.modelClassName ==
        "com.bami.service.tms.v3.admin.print.vo.AdminDispatchPrintDataV3tmsVo"
      ) {
        // 获取this.selectTableData中选择数据的outgoingId数组，作为预览的数据
        let idarr = [];
        for (let i = 0; i < this.selectTableData.length; i++) {
          idarr.push(this.selectTableData[i].dispatchId);
        }
        // 获取发车配载清单数据
        this.$API
          .getDispatchPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                _this.ajaxData = result;
                hiprintTemplate.print(_this.ajaxData, {});
              }
            }
          });
      } else if (
        this.modelClassName ==
        "com.bami.service.tms.v3.admin.print.vo.AdminOtherFinanceOnePrintDataV3tmsVo"
      ) {
        // 获取this.selectTableData中选择数据的outgoingId数组，作为预览的数据
        let idarr = [];
        for (let i = 0; i < this.selectTableData.length; i++) {
          idarr.push(this.selectTableData[i].otherId);
        }
        // 获取费用报销-单条
        this.$API
          .getOtherFinanceOnePrintData({
            otherFinanceIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                _this.ajaxData = result;
                hiprintTemplate.print(_this.ajaxData, {});
              }
            }
          });
      } else if (
        this.modelClassName ==
        "com.bami.service.tms.v3.admin.print.vo.AdminOtherFinanceMorePrintDataV3tmsVo"
      ) {
        // 获取this.selectTableData中选择数据的outgoingId数组，作为预览的数据
        let idarr = [];
        for (let i = 0; i < this.selectTableData.length; i++) {
          idarr.push(this.selectTableData[i].otherId);
        }
        // 获取费用报销-多条
        this.$API
          .getOtherFinanceMorePrintData({
            otherFinanceIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                _this.ajaxData = result;
                hiprintTemplate.print(_this.ajaxData, {});
              }
            }
          });
      }
      // 是使用这个接口？

      // 还是使用这个接口？
    },
    // 保存
    save() {
      if (hiprintTemplate) {
        this.dialogVisible = true;
      }
    },
    // 确定保存数据
    handleConfirm() {
      this.jsonOut = JSON.stringify(hiprintTemplate.getJson() || {});
      this.$API
        .savePrintModel({
          isFooter: 1,
          isHeader: 1,
          modelName: this.form.modelName,
          modelType: this.form.modelType,
          content: this.jsonOut,
          modelId:
            this.modelObj && this.printType == 2 ? this.modelObj.modelId : "",
          className: this.className,
        })
        .then((res) => {
          if (res.status == 200) {
            if (res.data && res.data.status == "success") {
              this.$message({
                message: res.data.message,
                type: "success",
              });
            }
          }
          this.dialogVisible = false;
        });
    },
    // 清空
    clearPaper() {
      try {
        hiprintTemplate.clear();
      } catch (error) {
        this.$message.error(`操作失败: ${error}`);
      }
    },
  },
};
</script>
  
<style lang="less" scoped>
@mainColor: #ef7c1b;
.separate {
  color: #ccc;
  margin: 0 8px;
}
.custom-print-sys-content {
  * {
    box-sizing: border-box !important;
  }
  height: 100%;
  ::v-deep {
    * {
      box-sizing: border-box !important;
    }
    .hiprint-printPaper-content {
      width: 100% !important;
    }
    > .el-card__body {
      height: 100%;
      padding: 15px 20px 12px;
    }
    .hiprint-printElement-type {
      > li {
        margin-bottom: 10px;
      }
      > li > ul {
        display: flex;
        flex-wrap: wrap;
      }
      > li > ul > li {
        max-width: initial;
      }
      > li > ul > li > a {
        padding: 4px 4px;
        color: #1296db;
        line-height: 1;
        height: auto;
        text-overflow: ellipsis;
      }
    }
    .elinputscalebox {
      .el-input__inner {
        height: 40px;
      }
    }
  }

  .top-button-group {
    display: flex;
    width: 100%;
    ::v-deep {
      .el-input__inner {
        text-align: center;
      }
      .el-card__body {
        display: flex;
        justify-content: center;
      }
    }
    .top-button-group-1 {
      margin-right: 10px;
    }
    .top-button-group-2 {
      margin-left: 10px;
    }
  }
  .custom-print-sys-content-body {
    height: calc(100% - 147px);
    overflow: hidden;
    .body-left {
      height: 100%;
    }
    .body-middle {
      height: 100%;
    }
    .body-right {
      height: 100%;
    }
    .body-card {
      height: calc(100% - 8px);
      margin: 5px 2px;
      overflow: auto;
    }
  }
}

// // 默认图片
// /deep/ .hiprint-printElement-image-content {
//   img {
//     content: url("~@/assets/logo.png");
//   }
// }

// 设计容器
.card-design {
  overflow: hidden;
  overflow-x: auto;
  overflow-y: auto;
}

.print-custom-dialog-save {
  user-select: none;
  * {
    box-sizing: border-box !important;
  }
  ::v-deep {
    * {
      box-sizing: border-box !important;
    }
    .prop-tabs .hiprint-option-items.active {
      height: auto;
    }
    .el-dialog {
      border-radius: 6px;
      height: 245px;
      margin: 0 !important;
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .el-dialog__header {
      border-radius: 6px 6px 0 0;
      color: #666;
      border-bottom: 1px solid #e9e9e9;
      padding: 12px 20px 12px;
      background-color: #f9f9f9;
    }
    .el-dialog__footer {
      border-top: 1px solid #f0ecec;
      padding: 10px 20px;
      justify-content: flex-end !important;
    }
    .el-dialog__headerbtn {
      top: 15px;
      font-size: 18px;
    }
    .el-dialog__body {
      padding: 0;
      height: calc(100% - 101px);
      overflow: hidden;
      max-height: none !important;
    }
    .el-table__cell.gutter {
      background: #f6f6f6;
    }
  }
  .dialog-title {
    display: flex;
    align-items: center;
    height: 24px;
    width: 60%;
  }

  .dialog-title-left-icon {
    font-size: 20px;
    color: @mainColor;
  }

  .dialog-title-word {
    margin-left: 8px;
    font-size: 14px;
  }
  .dialog-body {
    height: 100%;
    padding: 20px 80px 20px 20px;
  }
}
</style>
  